import { Button, Alert, Progress, Card, Upload } from '@nackle/paper';
import { CloudUpload, CloudDownload, Play, Cross } from '@nackle/icons';
import { Code } from '@nackle/icons/dist/react-es/antd-filled';
import React, { Component } from 'react';
import { formatFileSize } from 'utils/file-sizes';
import './rom-upload.less';

const { Dragger } = Upload;

interface RomUploadProps {
    readonly resource?: string;
    readonly handleRomFile: (result: Blob | null, name: string | null) => void;
    readonly onRemove: () => void;
    readonly romFile?: Blob;
    readonly onPlayRomFile: () => any;
}

interface State {
    file: File | null;
    loading: boolean;
}

export default class RomUpload extends Component<RomUploadProps, State> {
    state: State = {
        file: null,
        loading: false
    };

    componentDidUpdate(prevProps) {
        if (!!prevProps.romFile && !this.props.romFile) {
            this.setState({ file: null });
        }
    }

    onDrop = async (info) => {
        this.setState({ loading: true });
        const reader = new FileReader();
        await reader.addEventListener('loadend', () => this.props.handleRomFile(info.file, info.file.name), false);
        reader.readAsArrayBuffer(info.file);
        this.setState({ file: info.file, loading: false });
    };

    render() {
        const { resource } = this.props;

        const { file, loading } = this.state;

        const draggerProps = {
            name: 'file',
            customRequest: this.onDrop
        };

        const romUploadedButtons = (
            <>
                 <Button
                    type="primary"
                    className="download-value-button"
                    icon={<CloudDownload/>}
                    href={resource}
                    target="_blank"
                    rel="noopener"
                >
                    Download ROM
                </Button>
                &nbsp;
                <Button
                    type="primary"
                    className="play-value-button"
                    icon={<Play/>}
                    onClick={this.props.onPlayRomFile}
                >
                    Play ROM
                </Button>
                &nbsp;
            </>
        );

        const clearRomButton = (
            <Button
                type="primary"
                icon={<Cross/>}
                className="remove-value-button"
                onClick={this.props.onRemove}
            >
                Clear Selection
            </Button>
        );

        if (file) {
            return (
                <Card
                    title="ROM File: "                   
                    className={'rom-file-or-resource-wrapper'}
                >
                    <p className="rom-file-description">
                        <Code className="dragger-icons" />
                        { resource ? 'Uploaded ' : 'New ' }
                        ROM File: {file.name} ({formatFileSize(file.size)} bytes)
                    </p>
                    { resource ?
                        <Alert message="Upload complete"/> :
                        <Alert message="ROM will be uploaded when you save your changes"/>
                    }
                    { resource && romUploadedButtons }
                    { clearRomButton }
                </Card>
            );
        }

        if (resource) {
            return (
                <Card
                    title={
                        <>
                            <Code className="dragger-icons" />
                            Existing ROM File
                        </>
                    }
                    className={'rom-file-or-resource-wrapper'}
                >
                    {romUploadedButtons}
                    {clearRomButton}
                </Card>
            );
        }

        if (loading) {
            return (
                <Card
                    title="Uploading..."
                    className={'rom-file-or-resource-wrapper'}
                >
                    <Progress />
                </Card>
            );
        }

        return (
            <Dragger {...draggerProps}>
                <Card
                    title={
                        <>
                            <Code className="dragger-icons" />
                            No ROM File Selected
                        </>
                    }
                    className="rom-upload"
                >
                    <div className="nkl-btn nkl-btn-lg">
                        <CloudUpload style={{paddingRight: 8, fontSize: 16}} />
                        Drop files here, or click to select files
                    </div>
                </Card>
            </Dragger>
        );
    }
}

